export default "__VITE_ASSET__CpL0PNPZ__"